<template>
    <span class="multiselect__tag">
    <span>{{tag}}</span>
    <i aria-hidden="true" @click="props.remove()" class="multiselect__tag-icon"></i></span>
</template>

<script>
  export default {
    props: ['propsLabel', 'props'],
    computed: {
      tag() {
        return this.propsLabel && this.props ? this.props.option[this.propsLabel] : ''
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/multiselectTagSlot.vue